module.exports = __webpack_public_path__ + "static/media/mra_ceoImg.7ef6a9fd.jpg";